import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { swiperNavigation } from '../modules/swiperModules';

class InspirationGallery {
    constructor(el) {
        if (!el) {
            return;
        }

        this.root = el;
        this.arrowsEl = this.root.querySelector('.slider-arrows');
        this.swiperInstance = null;
        this.init();
    }

    destroy() {
        this.swiperInstance?.destroy(true, true);
        this.swiperInstance = null;
    }

    init() {
        const args = {
            slidesPerView: 1,
            modules: [Navigation],
            speed: 700,
        };

        if (this.arrowsEl) {
            Object.assign(args, swiperNavigation(this.arrowsEl));
        }

        this.swiperInstance = new Swiper(this.root, args);
    }
}

export const initInspirationGallery = el => {
    if (!el) {
        return null;
    }

    if (el._inspirationGalleryInstance) {
        el._inspirationGalleryInstance.destroy();
        el._inspirationGalleryInstance = null;
    }

    const instance = new InspirationGallery(el);
    el._inspirationGalleryInstance = instance;

    return instance;
};

window.mdaInitInspirationGallery = initInspirationGallery;
